import React from "react";
import { StyledPagination, StyledTablePagination } from "../StyledComponents/styled";
import { Box, Stack } from "@mui/material";

const NumberedModalPagination = ({
  totalCount,
  defaultSelectedPage,
  changeCall,
  rowSizeChangeCall,
  rowSize,
  totalRecordCount,
  boxWidth
}) => {
  const handleChangeRowsPerPage = (event) => {
    rowSizeChangeCall(parseInt(event.target.value, 10));
  };

  return (
    <Box sx={{ width: "100%", mt: -1.5 }}>
      {/* --------- Left: Total records info --------- */}
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <StyledTablePagination
          sx={{ paddingLeft: "0px" }}
          rowsPerPageOptions={[]}
          component="div"
          count={totalRecordCount}
          page={parseInt(defaultSelectedPage - 1)}
          onPageChange={() => { }}
          rowsPerPage={rowSize}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={() => null}
          labelDisplayedRows={({ from, to, count }) => `Showing ${from} - ${to} of ${count}`}
        />
        {/* --------- Center: Page navigation + row size --------- */}
        <Stack direction="row" alignItems="baseline" spacing={1}>
          <StyledPagination
            count={totalCount}
            onChange={changeCall}
            variant="text"
            page={defaultSelectedPage}
            siblingCount={2}
            sx={{ marginTop: "0px !important" }}
          />

          <StyledTablePagination
            rowsPerPageOptions={[10, 20, 50, 100]}
            component="div"
            count={totalRecordCount}
            page={defaultSelectedPage - 1}
            onPageChange={() => { }}
            rowsPerPage={rowSize}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={() => null}
            labelDisplayedRows={() => null}
          />
        </Stack>
        {/* --------- Right: Empty spacer for balance --------- */}
        <Box sx={{ visibility: "hidden" }}>
          <StyledTablePagination
            component="div"
            count={totalCount}
            page={defaultSelectedPage}
            onPageChange={() => { }}
            rowsPerPageOptions={[]}
            rowsPerPage={rowSize}
            onRowsPerPageChange={() => { }}
            ActionsComponent={() => null}
            labelDisplayedRows={({ from, to, count }) => `Showing ${from} - ${to} of ${count}`}
            sx={{
              ".MuiTablePagination-toolbar": {
                padding: 0,
                minHeight: "auto",
              },
              ".MuiTablePagination-spacer": {
                display: "none",
              },
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default NumberedModalPagination;